import { IVillageSuggest } from '../../types/village';
import {
  IGeoCodeCachedItem,
  IGeoCodedForSearch,
  ILocationType,
  IRegionByDomain,
  ISearchCatalogItem,
} from '../../types/geo';
import { IRegion } from '../../components/cian/location_switcher/util';
import { IBuilderSuggest } from '../../types/builder';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IGetRegionByDomainFetched } from '../filters/actions';
import { ICity } from './index';
import { ITypedReduxAction } from '../../types/store';

export enum EGeoActions {
  GeoCachedFetched = 'GeoCachedFetched',
  GeoLoadingStarted = 'GeoLoadingStarted',
  GeocodedForSearchFetched = 'GeocodedForSearchFetched',
  GeocodedForSearchError = 'GeocodedForSearchError',
  GeoCachedError = 'GeoCachedError',
  RegionsFetched = 'RegionsFetched',
  RegionCitiesFetchStarted = 'RegionCitiesFetchStarted',
  RegionCitiesFetched = 'RegionCitiesFetched',
  RegionCitiesFetchError = 'RegionCitiesFetchError',
  GeoUpdateRegion = 'GeoUpdateRegion',
  RegionsCitiesFetchStarted = 'RegionsCitiesFetchStarted',
  RegionsCitiesFetched = 'RegionsCitiesFetched',
  RegionsCitiesFetchError = 'RegionsCitiesFetchError',
  GeoUpdateCity = 'GeoUpdateCity',
  GetRegionByDomainFetched = 'GetRegionByDomainFetched',
  RegionFetched = 'RegionFetched',
  RegionFetchError = 'RegionFetchError',
  VillageSuggestionsFetched = 'VillageSuggestionsFetched',
  VillageSuggestionsFetchError = 'VillageSuggestionsFetchError',
  BuilderSuggestionsFetched = 'BuilderSuggestionsFetched',
  BuilderSuggestionsFetchError = 'BuilderSuggestionsFetchError',
  LocationInfoFetched = 'LocationInfoFetched',
  LocationInfoFetchError = 'LocationInfoFetchError',
}

export type TGeoCachedFetched = ITypedReduxAction<EGeoActions.GeoCachedFetched, IGeoCodeCachedItem[]>;
export const geoCachedFetched: (payload: IGeoCodeCachedItem[]) => TGeoCachedFetched = actionGenerator<
  EGeoActions.GeoCachedFetched,
  IGeoCodeCachedItem[]
>(EGeoActions.GeoCachedFetched);

export type TRegionsFetched = ITypedReduxAction<EGeoActions.RegionsFetched, IRegion[]>;
export const regionsFetched: (payload: IRegion[]) => TRegionsFetched = actionGenerator<
  EGeoActions.RegionsFetched,
  IRegion[]
>(EGeoActions.RegionsFetched);

export type TGeoCachedError = ITypedReduxAction<EGeoActions.GeoCachedError, string>;
export const geoCachedError: (payload: string) => TGeoCachedError = actionGenerator<EGeoActions.GeoCachedError, string>(
  EGeoActions.GeoCachedError,
);

export type TGeocodedForSearchFetched = ITypedReduxAction<EGeoActions.GeocodedForSearchFetched, IGeoCodedForSearch>;
export const geocodedForSearchFetched: (payload: IGeoCodedForSearch) => TGeocodedForSearchFetched = actionGenerator<
  EGeoActions.GeocodedForSearchFetched,
  IGeoCodedForSearch
>(EGeoActions.GeocodedForSearchFetched);

export type TGeocodedForSearchError = ITypedReduxAction<EGeoActions.GeocodedForSearchError, string>;
export const geocodedForSearchError: (payload: string) => TGeocodedForSearchError = actionGenerator<
  EGeoActions.GeocodedForSearchError,
  string
>(EGeoActions.GeocodedForSearchError);

export type TGeoLoadingStarted = ITypedReduxAction<EGeoActions.GeoLoadingStarted, void>;
export const geoLoadingStarted: () => TGeoLoadingStarted = actionGenerator<EGeoActions.GeoLoadingStarted>(
  EGeoActions.GeoLoadingStarted,
);

export type TRegionCitiesFetchStarted = ITypedReduxAction<EGeoActions.RegionCitiesFetchStarted, void>;
export const regionCitiesFetchStarted: () => TRegionCitiesFetchStarted =
  actionGenerator<EGeoActions.RegionCitiesFetchStarted>(EGeoActions.RegionCitiesFetchStarted);

export type TRegionCitiesFetched = ITypedReduxAction<EGeoActions.RegionCitiesFetched, ICity[]>;
export const regionCitiesFetched: (payload: ICity[]) => TRegionCitiesFetched = actionGenerator<
  EGeoActions.RegionCitiesFetched,
  ICity[]
>(EGeoActions.RegionCitiesFetched);

export type TRegionCitiesFetchError = ITypedReduxAction<EGeoActions.RegionCitiesFetchError, void>;
export const regionCitiesFetchError: () => TRegionCitiesFetchError =
  actionGenerator<EGeoActions.RegionCitiesFetchError>(EGeoActions.RegionCitiesFetchError);

export type TGeoUpdateRegion = ITypedReduxAction<EGeoActions.GeoUpdateRegion, ICity>;

export interface IGeoUpdateCityPayload {
  city: ICity;
  region: ICity;
}

export type TGeoUpdateCity = ITypedReduxAction<EGeoActions.GeoUpdateCity, IGeoUpdateCityPayload>;
export const geoUpdateCityAction: (payload: IGeoUpdateCityPayload) => TGeoUpdateCity = actionGenerator<
  EGeoActions.GeoUpdateCity,
  IGeoUpdateCityPayload
>(EGeoActions.GeoUpdateCity);

export type TRegionsCitiesFetchStarted = ITypedReduxAction<EGeoActions.RegionsCitiesFetchStarted, void>;
export const regionsCitiesFetchStarted: () => TRegionsCitiesFetchStarted =
  actionGenerator<EGeoActions.RegionsCitiesFetchStarted>(EGeoActions.RegionsCitiesFetchStarted);

export type TRegionsCitiesFetched = ITypedReduxAction<EGeoActions.RegionsCitiesFetched, ISearchCatalogItem[]>;
export const regionsCitiesFetched: (payload: ISearchCatalogItem[]) => TRegionsCitiesFetched = actionGenerator<
  EGeoActions.RegionsCitiesFetched,
  ISearchCatalogItem[]
>(EGeoActions.RegionsCitiesFetched);

export type TRegionsCitiesFetchError = ITypedReduxAction<EGeoActions.RegionsCitiesFetchError, void>;
export const regionsCitiesFetchError: () => TRegionsCitiesFetchError =
  actionGenerator<EGeoActions.RegionsCitiesFetchError>(EGeoActions.RegionsCitiesFetchError);

export type TRegionFetched = ITypedReduxAction<EGeoActions.RegionFetched, IRegionByDomain>;
export const regionFetched: (payload: IRegionByDomain) => TRegionFetched = actionGenerator<
  EGeoActions.RegionFetched,
  IRegionByDomain
>(EGeoActions.RegionFetched);

export type TRegionFetchError = ITypedReduxAction<EGeoActions.RegionFetchError, void>;
export const regionFetchError: () => TRegionFetchError = actionGenerator<EGeoActions.RegionFetchError>(
  EGeoActions.RegionFetchError,
);

export type TVillageSuggestionsFetched = ITypedReduxAction<EGeoActions.VillageSuggestionsFetched, IVillageSuggest[]>;
export const villageSuggestionsFetched: (payload: IVillageSuggest[]) => TVillageSuggestionsFetched = actionGenerator<
  EGeoActions.VillageSuggestionsFetched,
  IVillageSuggest[]
>(EGeoActions.VillageSuggestionsFetched);

export type TVillageSuggestionsFetchError = ITypedReduxAction<EGeoActions.VillageSuggestionsFetchError, void>;
export const villageSuggestionsFetchError: () => TVillageSuggestionsFetchError =
  actionGenerator<EGeoActions.VillageSuggestionsFetchError>(EGeoActions.VillageSuggestionsFetchError);

export type TBuilderSuggestionsFetched = ITypedReduxAction<EGeoActions.BuilderSuggestionsFetched, IBuilderSuggest[]>;
export const builderSuggestionsFetched: (payload: IBuilderSuggest[]) => TBuilderSuggestionsFetched = actionGenerator<
  EGeoActions.BuilderSuggestionsFetched,
  IBuilderSuggest[]
>(EGeoActions.BuilderSuggestionsFetched);

export type TBuilderSuggestionsFetchError = ITypedReduxAction<EGeoActions.BuilderSuggestionsFetchError, void>;
export const builderSuggestionsFetchError: () => TBuilderSuggestionsFetchError =
  actionGenerator<EGeoActions.BuilderSuggestionsFetchError>(EGeoActions.BuilderSuggestionsFetchError);

export type TLocationInfoFetched = ITypedReduxAction<EGeoActions.LocationInfoFetched, ILocationType | undefined>;

export type TLocationInfoFetchError = ITypedReduxAction<EGeoActions.LocationInfoFetchError, void>;

export type Action =
  | TGeoCachedFetched
  | TGeoLoadingStarted
  | TGeocodedForSearchFetched
  | TGeocodedForSearchError
  | TGeoCachedError
  | TRegionsFetched
  | TRegionCitiesFetchStarted
  | TRegionCitiesFetched
  | TRegionCitiesFetchError
  | TGeoUpdateRegion
  | TRegionsCitiesFetchStarted
  | TRegionsCitiesFetched
  | TRegionsCitiesFetchError
  | TGeoUpdateCity
  | IGetRegionByDomainFetched
  | TRegionFetched
  | TRegionFetchError
  | TVillageSuggestionsFetched
  | TVillageSuggestionsFetchError
  | TBuilderSuggestionsFetched
  | TBuilderSuggestionsFetchError
  | TLocationInfoFetched
  | TLocationInfoFetchError;
